// import { useContext, useState} from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";

let myAbilities = HelpAbility();

function ItemModal({i, direccion: direc, vinculedDireccion}) {
    const { alias, codCiudad, codDepartamento, mailClient, /*_id*/ } = direc;

    const handleVinculedDirection = () => {
        vinculedDireccion({direccion: direc});
    }
    return (
        <tr>
            <th className="text-center" scope="row">{i + 1}</th>
            <td className="text-center">{alias}</td>
            <td className="text-center">{codCiudad}</td>
            <td className="text-center">{codDepartamento}</td>

            {myAbilities.hasAny([C.A.CUSTOMER.LINKDIRECTION]) && <td className="text-center d-flex">
                {myAbilities.has(C.A.CUSTOMER.LINKDIRECTION) &&

                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Vincular Direccion</Tooltip>}>
                        <button type="button"
                            className="btn btn-sm btn-info me-2"
                            onClick={handleVinculedDirection}
                            disabled={mailClient ? true : false}
                            >
                            <i className="bi bi-person-fill" />
                        </button>
                    </OverlayTrigger>}

            </td>}
        </tr>
    )
}
export default ItemModal